module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-muted small"
  }, [_c('b-popover', {
    attrs: {
      "content": _vm.editorExplanationContent,
      "triggers": ['click', 'focus']
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-question-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('editor.explanation')) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0195789a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditorExplanation.vue
// module id = 464
// module chunks = 0